import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import React, { useState } from 'react';
import { hasGoogleClientId } from '../config/googleClient';

/** GIS Sign-In With Google — ID token only (openid email profile). No Drive/People scopes. */
const GOOGLE_ID_SCOPES = 'openid email profile';

const AuthenticationComponent = ({ onLogin, onError, onDevLogin }) => {
  const [isLoading, setIsLoading] = useState(false);
  const showGoogle = hasGoogleClientId();

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const decodedToken = jwtDecode(credentialResponse.credential);
      await onLogin(decodedToken, credentialResponse.credential);
    } catch (error) {
      console.error('Google login error:', error);
      onError('Failed to process Google login. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDevLogin = async () => {
    if (!onDevLogin) return;
    setIsLoading(true);
    try {
      await onDevLogin();
    } catch (error) {
      console.error('Dev login error:', error);
      onError(error?.message || 'Dev login failed.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Sign in to Cloud Canvas
      </Typography>
      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <>
          {onDevLogin && (
            <Button variant="contained" color="inherit" onClick={handleDevLogin}>
              Continue as Dev
            </Button>
          )}
          {showGoogle && (
            <GoogleLogin
              scope={GOOGLE_ID_SCOPES}
              onSuccess={handleGoogleLoginSuccess}
              onError={() => {
                console.error('Google Login Failed');
                onError(
                  'Google login failed. Add this UI origin to the OAuth client Authorized JavaScript origins.'
                );
              }}
              useOneTap={false}
              auto_select={false}
              theme="filled_blue"
              shape="pill"
              text="continue_with"
            />
          )}
        </>
      )}
    </Box>
  );
};

export default AuthenticationComponent;
